module.exports = __webpack_public_path__ + "static/media/2.58806531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/bobruisk/2.jpg
// module id = 211
// module chunks = 0